<template>
	<div class="cloud-Detail">
		<div class="cloud-detail-title">
			<div class="cloud-detail-title-title">
				<img src="@/assets/images/groupTitle.png" alt="" />
				<p>省份列表</p>

				<dv-decoration-3 class="decoration-container" :style="{ width: '10%', height: '30px' }"
					style="margin-top: -35px; margin-left: 87%;">
					<!-- 插槽中添加多个小方块 -->
					<div slot="content" class="squares-container">
						<div class="square s1"></div>
						<div class="square s2"></div>
						<div class="square s3"></div>
						<div class="square s4"></div>
						<div class="square s5"></div>
						<div class="square s6"></div>
					</div>
				</dv-decoration-3>
			</div>
			<div class="cloud-detail-title-content">
				<ul class="cloud-detail-title-content-ul">
					<li v-for="(item, index) in dataList" :key="index" :class="{ 'active': activeIndex1 === index }"
						@click="activeClick(index)">
						<div>
							<p>{{ item.name }}</p>
							<p>{{ item.num }}</p>
						</div>
						<div>
							<div>
								<p>{{ item.onlineNum }}</p>
								<p><img src="@/assets/images/online.png" alt="" /> 在线</p>
							</div>
							<div>
								<p>{{ item.offlineNum }}</p>
								<p><img src="@/assets/images/offline.png" alt="" /> 离线</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<div class="cloud-detail-title1" style="">
			<div class="cloud-detail-content">
				<div class="cloud-detail-content-title">
					<img src="@/assets/images/groupTitlec.png" alt="" />
					<p>项目列表</p>
					<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
						style="position: absolute; top: 5px; margin-left: 96%;">
						<!-- 插槽中添加多个小方块 -->
						<div slot="content" class="squares-container">
							<div class="square s1"></div>
							<div class="square s2"></div>
							<div class="square s3"></div>
							<div class="square s4"></div>
							<div class="square s5"></div>
							<div class="square s6"></div>
						</div>
					</dv-decoration-3>
				</div>
				<ul class="cloud-detail-content-ul">
					<li v-for="(item, index) in dataList[activeIndex1]?.tunnelArry" :key="index"
						:class="{ 'active': activeIndex2 === index }" @click="activeIndex2 = index"
						:style="{ backgroundImage: `url(${getTunnelBg(item.itemTunnelType)})` }">
						<div>
							<p>{{ item.itemName }}</p>
							<p></p>
						</div>
						<div @click="handleClick(item)">
							<div>
								<p>地址</p><span>{{ item.itemAddr || '-' }} </span>
							</div>
							<div>
								<p>开始时间</p><span>{{ item.planBeginDate || '-' }}</span>
							</div>
							<div>
								<p>结束时间</p><span>{{ item.planCompleteDate || '-' }}</span>
							</div>
							<div>
								<p>状态</p><span>{{ item.status || '-' }}</span>
							</div>
						</div>
						<p></p>
					</li>
				</ul>
			</div>

			<div class="cloud-detail-content-project">
				<div class="cloud-detail-content-project-title">
					<img src="@/assets/images/groupTitlec.png" alt="" />
					<p>现场视频</p>
					<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
						style="position: absolute; top: 1px; margin-left: 96%;">
						<!-- 插槽中添加多个小方块 -->
						<div slot="content" class="squares-container">
							<div class="square s1"></div>
							<div class="square s2"></div>
							<div class="square s3"></div>
							<div class="square s4"></div>
							<div class="square s5"></div>
							<div class="square s6"></div>
						</div>
					</dv-decoration-3>
				</div>
				<ul class="cloud-detail-content-project-ul">
					<li v-for="(item, index) in videoData" :key="index">
						<!-- <img :src="item.img" alt="" style="width: 100%; height: 100%; object-fit: cover;" /> -->
						<video :ref="`videoRef${index}`" controls preload="auto" width="98%" height="99%" muted 
							poster="https://example.com/cover.jpg" @loadeddata="handleVideoLoaded(index)"
							@error="handleVideoError(index)">
							<source :src="item.videoUrl" type="video/mp4">
							您的浏览器不支持 HTML5 视频播放，请升级浏览器！
						</video>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { getstatisticsTunnelCount } from '@/public/api.js'
import city from "@/utils/city.json";
import ScreenShot1 from "@/assets/temp/ScreenShot_2025-11-06_102328_433.png";
import ScreenShot2 from "@/assets/temp/ScreenShot_2025-11-06_102346_722.png";
import videoUrls1 from "@/assets/temp/a46817246f19a877f0f10309ee00acb0.mp4";
import videoUrls2 from "@/assets/temp/d3be269fda1c2f665cd7c32d70d2ad12.mp4";

import jksd from "@/assets/images/jksd.png";
import cksd from "@/assets/images/cksd.png";
import dxj from "@/assets/images/dxj.png";
import std from "@/assets/images/std.png";
import dxstd from "@/assets/images/dxstd.png";
import stdxj from "@/assets/images/stdxj.png";
import { ProvinceData } from './components/testData/ProvinceData'


// 引入路由实例
export default {
	name: 'Detail',
	components: {
	},
	data() {
		return {
			dataList: [],
			activeIndex1: 0,
			activeIndex2: 0,
			videoData: [
				{
					name: '现场视频1',
					img: ScreenShot1,
					videoUrl: videoUrls1
				}, {
					name: '现场视频1',
					img: ScreenShot1,
					videoUrl: videoUrls2
				},
			],
			// 类型-图片映射（Vue 2 放在 data 或 computed 中）
			tunnelBgMap: {
				'1': jksd,
				'2': cksd,
				'3': dxj,
				'4': std,
				'5': dxstd,
				'7': stdxj
			},
			videoTimer: {}, // 存储每个视频的延迟定时器（避免冲突）
			videoLoaded: {} // 存储每个视频的加载状态
		}
	},
	computed: {

	},
	mounted() {
		this.refreshKey += 1;
		let that = this;
		getstatisticsTunnelCount({}).then(res => {
			if (res.data.code == 200) {
				let dataDom = res.data.data;
				let tunnelCount = 0;
				let tunnelArry = [];
				let DepartmentListData = JSON.parse(localStorage.getItem('transferDepartmentListData'));

				let hostNames = window.location.hostname;
				if (hostNames == '127.0.0.1' || hostNames == '39.100.79.198' || hostNames == 'sd.yongsixinxi.com') {
					dataDom = ProvinceData()
				}

				dataDom.forEach(item => {
					city.forEach(itemCity => {
						if (itemCity.value === item.provinceId) {
							tunnelCount = 0;
							tunnelArry = [];

							DepartmentListData.forEach(itemDepartment => {
								itemDepartment.children.forEach(RowsDepartment => {
									if (RowsDepartment.proId === item.provinceId) {
										tunnelCount += 1;
										if (hostNames == '127.0.0.1' || hostNames == '39.100.79.198' || hostNames == 'sd.yongsixinxi.com') {
											tunnelCount = item.count || 0;
										}

										tunnelArry.push({
											itemName: RowsDepartment.itemName,
											itemId: RowsDepartment.itemId,
											itemAddr: RowsDepartment.itemAddr,
											planBeginDate: RowsDepartment.planBeginDate,
											planCompleteDate: RowsDepartment.planCompleteDate,
											itemTunnelType: RowsDepartment.itemTunnelType,
											status: RowsDepartment.status,
										})
									}
								})
							})


							that.dataList.push({
								name: itemCity.label,
								num: tunnelCount,
								onlineNum: tunnelCount,
								offlineNum: 0,
								provinceId: item.provinceId,
								tunnelArry: tunnelArry
							})
						}
					})

				})

				let hostName = window.location.hostname;

				if (hostName == '127.0.0.1' || hostName == '39.100.79.198' || hostName == 'sd.yongsixinxi.com') {
					this.activeIndex1 = 6;
				}
			}
		})
		// 组件挂载后，为每个视频启动 5秒延迟播放（需等待加载就绪）
		this.videoData.forEach((_, index) => {
			this.videoTimer[index] = setTimeout(() => {
				this.autoPlayVideo(index);
			}, 5000); // 5秒延迟
		});
	},
	methods: {
		handleClick(item) {
			localStorage.setItem('updateLhTunnels', JSON.stringify(item));
			this.$router.push({
				path: '/detailDetach',
			});
		},
		activeClick(index) {

			let hostName = window.location.hostname;

			if (hostName == '127.0.0.1' || hostName == '39.100.79.198' || hostName == 'sd.yongsixinxi.com') {
				this.activeIndex1 = 6;
			} else {
				this.activeIndex1 = index;
			}
		},
		// 根据 itemTunnelType 获取背景图
		getTunnelBg(type) {
			// 匹配不到类型时返回空字符串，避免背景图语法报错
			return this.tunnelBgMap[type] || '';
		},
		// 单个视频加载完成
		handleVideoLoaded(index) {
			this.videoLoaded[index] = true;
		},
		// 单个视频加载失败
		handleVideoError(index) {
			this.videoLoaded[index] = false;
			clearTimeout(this.videoTimer[index]); // 加载失败，清除该视频的定时器
		},
		// 自动播放核心逻辑
		autoPlayVideo(index) {
			const video = this.$refs[`videoRef${index}`]?.[0]; // 获取单个视频实例
			if (!video) return;

			// 1. 先判断视频是否加载就绪
			if (video.readyState < 2) { // readyState < 2 表示未加载完成
				// 监听加载完成后再播放
				video.addEventListener('loadeddata', () => this.doPlay(video));
				return;
			}

			// 2. 加载就绪，执行播放
			this.doPlay(video);
		},
		// 执行播放（处理浏览器自动播放限制）
		doPlay(video) {
			// 浏览器自动播放政策：需用户交互后才能播放带声音的视频
			// 尝试带声音播放
			video.play().catch(error => {
				console.log('带声音播放失败（浏览器限制），尝试静音播放：', error);
				// 失败则静音后播放（大部分浏览器允许静音自动播放）
				video.muted = true;
				video.play().catch(err => {
					console.log('静音播放仍失败，请用户手动点击播放：', err);
					// 最终失败：提示用户手动操作（可选）
					alert('视频自动播放失败，请点击视频控件播放~');
				});
			});
		}
	},
	beforeDestroy() {

	},
	beforeUnmount() {
		// 组件卸载时清除所有定时器（避免内存泄漏）
		Object.values(this.videoTimer).forEach(timer => clearTimeout(timer));
	},
}
</script>
<style scoped>
.cloud-Detail {
	position: relative;
	top: 1%;
	left: 10px;
	width: 98%;
	height: 100%;
	margin: 0;
	padding: 0;

	>.cloud-detail-title {
		position: absolute;
		top: 1vh;
		left: 0;
		width: calc(400 / 1920 * 100vw);
		height: calc(960 / 1080 * 100vh);
		background: rgba(0, 0, 0, 0.4);
		border-radius: 10px;

		.cloud-detail-title-title {
			position: relative;
			top: 0px;
			left: 0px;
			width: 100%;
			height: 2.5vh;
			margin: 0;
			padding: 0;

			img {
				width: 100%;
				height: auto;
				margin: 0;
				padding: 0;
			}

			p {
				position: absolute;
				top: 0.3vh;
				left: 3.01vh;
				width: 100%;
				height: 2.5vh;
				margin: 0;
				padding: 0;
				font-size: 1.0rem;
				color: #fff;
				text-align: left;
			}
		}

		.cloud-detail-title-content {
			position: relative;
			top: 0px;
			left: 0px;
			width: 94%;
			height: calc(900 / 1080 * 100vh);
			margin: 0;
			padding: 0;
			overflow-y: auto;
			scrollbar-width: thin;
			scrollbar-color: rgba(150, 150, 150, 0.2) transparent;

			>.cloud-detail-title-content-ul {
				list-style: none;
				margin: 0;
				padding: 5%;
				text-align: left;

				>li {
					/* 原有样式保留，新增过渡效果（让阴影变化更丝滑） */
					transition: box-shadow 0.3s ease;

					/* 鼠标移入：添加四周阴影 */
					&:hover {
						box-shadow: 0 0 12px 2px rgba(43, 220, 255, 0.6);
					}

					/* 选中状态：添加更明显的四周阴影（可自定义颜色和强度） */
					&.active {
						box-shadow: 0 0 15px 3px rgba(34, 137, 255, 0.8);
						/* 可选：选中时加深边框色，增强视觉区分 */
						border-color: #2289FF;
					}

					>div:nth-child(1) {
						/* 原有样式不变 */
					}

					>div:nth-child(2) {
						/* 原有样式不变 */
					}

					position: relative;
					top: 0px;
					left: 0px;
					width: 104%;
					height: 15vh;
					margin: 0;
					padding: 0;
					font-size: 1.0rem;
					color: #fff;
					text-align: left;
					border-radius: 0px 0px 0px 0px;
					border: 2px solid #2289FF;
					margin-top: 1.5vh;
					background: linear-gradient(147deg, rgba(2, 58, 158, 0.8) 0%, rgba(2, 58, 158, 0.3) 100%);

					>div:nth-child(1) {
						width: 100%;
						height: 3.5vh;
						margin: 0;
						padding: 0;
						background: radial-gradient(200% 100% at -2% 80%, rgba(0, 87, 242, 0.8) 0%, rgba(0, 87, 242, 0) 100%);

						>p {
							margin: 0px;
							padding: 0px;

							&:nth-child(1) {
								width: 60%;
								height: 3.5vh;
								line-height: 3.5vh;
								text-indent: 1em;
								float: left;
								font-family: PingFang SC, PingFang SC;
								font-size: 0.8rem;
							}

							&:nth-child(2) {
								width: 20%;
								height: 2.5vh;
								line-height: 2.5vh;
								text-align: center;
								float: right;
								font-family: PingFang SC, PingFang SC;
								font-size: 0.8rem;
								font-weight: bold;
								background: rgba(255, 255, 255, 0.12);
								border-radius: 14px 14px 14px 14px;
								color: #b0b0b0;
								margin-top: 5px;
								margin-right: 15px;
							}
						}
					}

					>div:nth-child(2) {
						width: 100%;
						height: 8.5vh;
						margin: 0;
						padding: 0;
						padding-top: 2vh;

						>div:nth-child(1) {
							width: 49%;
							height: 7.5vh;
							margin: 0;
							padding: 0;
							border-right: 1px solid rgba(255, 255, 255, 0.12);
							float: left;

							>p:nth-child(1) {
								font-size: 1.6rem;
								margin-top: 1vh;
								padding: 0px;
								margin-bottom: 0.5vh;
								color: #fff;
								text-align: center;
							}

							>p:nth-child(2) {
								font-size: 0.8rem;
								margin: 0;
								padding: 0px;
								color: #fff;
								text-align: center;
								font-size: 0.7rem;

								>img {
									width: 0.7vw;
									height: auto;
									margin: 0;
									padding: 0;
									margin-top: 0.5vh;
								}
							}
						}

						>div:nth-child(2) {
							width: 49%;
							height: 7.5vh;
							margin: 0;
							padding: 0;
							border-right: 1px solid rgba(255, 255, 255, 0.12);
							float: right;

							>p:nth-child(1) {
								font-size: 1.6rem;
								margin-top: 1vh;
								padding: 0px;
								margin-bottom: 0.5vh;
								color: #fff;
								text-align: center;
							}

							>p:nth-child(2) {
								font-size: 0.8rem;
								margin: 0;
								padding: 0px;
								color: #fff;
								text-align: center;
								font-size: 0.7rem;

								>img {
									width: 0.7vw;
									height: auto;
									margin: 0;
									padding: 0;
									margin-top: 0.5vh;
								}
							}
						}
					}
				}
			}
		}
	}



	>.cloud-detail-title1 {
		position: absolute;
		top: 0vh;
		left: calc(410 / 1920 * 100vw);
		width: calc(1490 / 1920 * 100vw);
		height: calc(960 / 1080 * 100vh);
		border-radius: 10px;

		.cloud-detail-content {
			position: absolute;
			top: 1vh;
			width: 100%;
			height: calc(660 / 1080 * 100vh);
			background: rgba(0, 0, 0, 0.4);
			border-radius: 10px;
			overflow-y: auto;
			overflow-x: hidden;
			scrollbar-width: thin;
			scrollbar-color: rgba(150, 150, 150, 0.2) transparent;

			>.cloud-detail-content-title {
				position: relative;
				top: 0px;
				left: 0px;
				width: 100%;
				height: 2.5vh;
				margin: 0;
				padding: 0;

				img {
					width: 68vw;
					height: auto;
					margin: 0;
					padding: 0;
					float: left;
				}

				p {
					position: absolute;
					top: 0.3vh;
					left: 3.01vh;
					width: 100%;
					height: 2.5vh;
					margin: 0;
					padding: 0;
					font-size: 1.0rem;
					color: #fff;
					text-align: left;
				}
			}

			>.cloud-detail-content-ul {
				list-style: none;
				margin: 0;
				padding: 0;
				text-align: left;

				>li {
					/* 原有样式保留，新增过渡效果（让阴影变化更丝滑） */
					transition: box-shadow 0.3s ease;

					/* 鼠标移入：添加四周阴影 */
					&:hover {
						box-shadow: 0 0 12px 2px rgba(43, 220, 255, 0.6);
					}

					/* 选中状态：添加更明显的四周阴影（可自定义颜色和强度） */
					&.active {
						box-shadow: 0 0 15px 3px rgba(34, 137, 255, 0.8);
						/* 可选：选中时加深边框色，增强视觉区分 */
						border-color: #2289FF;
					}

					>div:nth-child(1) {
						/* 原有样式不变 */
					}

					>div:nth-child(2) {
						/* 原有样式不变 */
					}

					position: relative;
					top: 0px;
					left: 0px;
					width: 28vh;
					height: 23vh;
					margin: 15px;
					margin-top: 10px;
					padding: 0;
					font-size: 1.0rem;
					text-align: left;
					border-radius: 0px 0px 0px 0px;
					border: 1px solid rgba(2, 58, 158, 0.8);
					/* background: linear-gradient(147deg, rgba(2, 58, 158, 0.8) 0%, rgba(2, 58, 158, 0.3) 100%); */
					box-shadow: 0 6px 6px -1px rgba(43, 220, 255, 0.4);
					float: left;

					>div:nth-child(1) {
						width: 100%;
						height: 3.5vh;
						margin: 0;
						padding: 0;
						/* background: radial-gradient(200% 100% at -2% 80%, rgba(0, 87, 242, 0.8) 0%, rgba(0, 87, 242, 0) 100%); */

						>p {
							margin: 0px;
							padding: 0px;

							&:nth-child(1) {
								width: 60%;
								height: 3.5vh;
								line-height: 3.5vh;
								text-indent: 1em;
								float: left;
								font-family: PingFang SC, PingFang SC;
								font-size: 0.8rem;
							}

							&:nth-child(2) {
								width: 1.5vh;
								height: 1.5vh;
								float: right;
								background: #1BFFB1;
								margin-top: 0.9vh;
								margin-right: 15px;
								border-radius: 50px;
							}
						}
					}

					>div:nth-child(2) {
						width: 100%;
						height: 13.5vh;
						margin: 0;
						padding: 0;
						padding-top: 2vh;

						>div {
							width: 100%;
							height: 2.5vh;
							margin: 0;
							padding: 0;

							>p {
								width: 30%;
								height: 2.5vh !important;
								line-height: 2vh !important;
								text-indent: 1em;
								float: left;
								font-family: PingFang SC, PingFang SC;
								font-size: 0.6rem;
								margin: 0;
								padding: 0;
								color: rgba(255, 255, 255, 0.7);
							}

							>span {
								font-family: PingFang SC, PingFang SC;
								font-size: 0.7rem;
								color: rgba(255, 255, 255, 0.9);
							}
						}
					}
				}
			}
		}

		.cloud-detail-content-project {
			position: absolute;
			top: calc(690 / 1080 * 100vh);
			width: calc(1490 / 1920 * 100vw);
			height: calc(280 / 1080 * 100vh);
			background: rgba(0, 0, 0, 0.4);
			border-radius: 10px;
			overflow-y: auto;
			overflow-x: hidden;
			scrollbar-width: thin;
			scrollbar-color: rgba(150, 150, 150, 0.2) transparent;

			>.cloud-detail-content-project-title {
				position: relative;
				top: 0px;
				left: 0px;
				width: 100%;
				height: 2.5vh;
				margin: 0;
				padding: 0;

				img {
					width: 68vw;
					height: auto;
					margin: 0;
					padding: 0;
					float: left;
				}

				p {
					position: absolute;
					top: 0.3vh;
					left: 3.01vh;
					width: 100%;
					height: 2.5vh;
					margin: 0;
					padding: 0;
					font-size: 1.0rem;
					color: #e0e0e0;
					text-align: left;
				}
			}

			>.cloud-detail-content-project-ul {
				list-style: none;
				margin: 0;
				padding: 0;
				text-align: left;

				>li {
					position: relative;
					top: 0px;
					left: 0px;
					width: 28vh;
					height: 17vh;
					margin: 15px;
					margin-top: 16px;
					padding: 0;
					font-size: 1.0rem;
					color: #fff;
					text-align: left;
					border-radius: 0px 0px 0px 0px;
					border: 1px solid rgba(2, 58, 158, 0.8);
					background: linear-gradient(147deg, rgba(2, 58, 158, 0.8) 0%, rgba(2, 58, 158, 0.3) 100%);
					box-shadow: 0 6px 6px -1px rgba(43, 220, 255, 0.4);
					float: left;

				}
			}
		}
	}
}
</style>